import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./ProjectCard.scss";

const ProjectCard = ({ projects }) => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);
  return (
    <Container>
      <h1 style={{ color: "#100028", }} className="mb-4 mt-4 mt-md-0 text-center headline">
        PROJECTS
      </h1>
      <Row>
        {projects.map((project) => (
          <Col
            data-aos="zoom-in"
            data-aos-duration="3000"
            sm={12}
            md={6}
            lg={4}
            key={project.id}
            className="pb-5 project-manage text-center"
          >
            <div style={{minHeight: "455px"}}>
              <img className="w-100" src={project.picture} alt="" />
            <h4>
              {project.title} <span>{project.time}</span>
            </h4>
            <p className="text-justify">{project.text}</p>
            </div>
            <div className="d-flex justify-content-around align-items-center">
              <button
                style={{
                  background: "white",
                  border: "2px solid #6b74ce",
                }}
                className="naked-button"
              >
                <a href={project.liveSite}>Visit site</a>
              </button>
              <button className="full-button">
                <a href={project.githubLink}>Github Link</a>
              </button>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default ProjectCard;
